export default "__VITE_ASSET__E61uw0pKteaGDjASw1dqSA__"